<template>
  <div :class="theme">
    <input :type="type" :class="['form-control', {'static-field': staticField}]" ref="input" v-model="inputData"
           :placeholder="placeholder" :readonly="readonly||staticField" autocomplete="off">
    <i v-if="!staticField" :class="['glyphicon', icon, {'input-active': inputData && inputData.length !== 0}]"></i>
  </div>
</template>

<script>
  export default {
    name: 'input-field',
    props: {
      theme: {
        type: String,
        default: 'default-theme'
      },
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      value: {
        default: ''
      },
      staticField: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        inputData: ''
      }
    },
    watch: {
      value: function () {
        this.inputData = this.value
      },
      inputData: function () {
        this.$emit('input', this.inputData)
      }
    },
    methods: {
    },
    mounted: function () {
      this.inputData = this.value
    }
  }
</script>

<style lang="scss" scoped>
  .default-theme {
    position: relative;
    input {
      height: 48px;
      width: 100%;
      padding: 16px 20px;
      border: solid 1px #e9ecef;
      border-radius: 0px;
    }
    i {
      color: $hzc-gray-03;
      position: absolute;
      z-index: 5;
      top: 16px;
      bottom: 16px;
      right: 20px;
    }

    i[readonly='readonly'] {
      color: $hzc-gray-05;
    }
    .input-active {
      color: $hzc-brand-07 !important;
    }
    .static-field {
      border: none;
      color: #adb5bd;
      background-color: #ffffff;
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/InputText.vue